import * as React from 'react';
import moment from 'moment';
import { Button, Col, DatePicker, Row, Skeleton, Spin, Table } from 'antd';
import { GraphqlQuery } from 'requestapijs';
import { TSAutoComplete } from '../common/TSAutoComplete';
import { TSInput } from '../common/TSInput';
import { Bussiness, CompanyNodeEdge } from '../master/Company/constants';
import { BranchCategory } from '../../schema';
import { ExpenseEntryNodeConnection } from './constants';
import { getValue } from '../common/AutoCompleteHelper';
import { expenseEntryWithDateRangeQuery } from './constants';
import { Pagination } from 'sha-el-design/lib';
import { EXPENSE_ENTRY_REPORT_CSV } from '../../config';
import { downloadToFile } from '../helper';

export class ExpenseEntryReportDateRange extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      startDate: moment().format('YYYY-MM-DD'),
      date: moment().format('YYYY-MM-DD'),
      currentPage: 1,
      after: '',
      head: '',
      branchId: props.branchId,
      isLoading: false,
      message: '',
      branchName: props.branchId ? props.business?.name : 'Head Office',
    };
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const nextState = { ...this.state };
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };

  columns = () => {
    const stockSummaryColumns: {
      title: string;
      dataIndex: string;
      key: string;
      render?: (data: any) => string | Number | JSX.Element;
    }[] = [];

    stockSummaryColumns.push(
      {
        title: 'Expense Head',
        dataIndex: 'node.expense.head',
        key: 'head',
      },
      {
        title: 'Date',
        dataIndex: 'node.date',
        key: 'date',
      },
      {
        title: 'Paid To',
        dataIndex: 'node.paidTo',
        key: 'paidTo',
      },
      {
        title: 'Payment Mode',
        dataIndex: 'node.paymentMode',
        key: 'paymentMode',
        render: (value) => value || 'Cash',
      },
      {
        title: 'Amount',
        dataIndex: 'node.amount',
        key: 'amount',
      },
      {
        title: 'Remarks',
        key: 'remarks',
        dataIndex: 'node.remarks',
      },
    );

    return stockSummaryColumns;
  };

  downloadCsv = (variables) => {
    const { startDate, date, companyId, branchId, head } = variables;
    let queryParams = `companyId=${companyId}&startDate=${startDate}&date=${date}`;
    queryParams += branchId ? `&branchId=${branchId}` : '';
    queryParams += head ? `&head=${head}` : '';

    this.setState({ isLoading: true, message: 'Please Wait' });

    fetch(EXPENSE_ENTRY_REPORT_CSV + '?' + queryParams)
      .then((value) => value.text())
      .then((csv) => {
        if (csv === 'Wait') {
          this.setState({
            message: 'Generating data. You can downlaod it after 10 to 15 mins',
          });
        } else if (csv === 'Creating') {
          this.setState({
            message: 'You have already requested for this data. Please wait!',
          });
        } else {
          const data = csv.split('####');
          downloadToFile(
            data[0],
            `expense-entry-date-range-report-${new Date()}-${btoa(data[1])}`,
            'EXPENSE ENTRY (DATE RANGE) REPORT',
            this.props.business?.type === 'branch'
              ? this.props.business.companyName || ''
              : this.props.business?.name || '',
            this.state.branchName ? this.state.branchName : 'Head Office',
            moment(this.state.startDate).format('DD-MM-YYYY'),
            moment(this.state.date).format('DD-MM-YYYY'),
            '',
          );
          this.setState({ message: '' });
        }
      })
      .then(() => this.setState({ isLoading: false }));
  };

  afterStack = [''];
  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  render() {
    const { startDate, date, currentPage, after, branchId, branchName } =
      this.state;
    const { companyId, business } = this.props;
    const variables = {
      startDate,
      date,
      companyId,
      branchId,
      first: 20,
      after,
      head: this.state.head,
    };
    const { head } = this.state;
    return (
      <>
        <Row>
          <Col span={4}>
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="Start Date"
              value={
                (this.state.startDate && moment(this.state.startDate)) || null
              }
              onChange={(date) =>
                this.onChange({
                  target: {
                    name: 'startDate',
                    value: date && moment(date).format('YYYY-MM-DD'),
                  },
                })
              }
              disabledDate={(currentDate) => {
                if (!currentDate || !this.state.date) {
                  return false;
                }
                return (
                  currentDate.valueOf() > moment(this.state.date).valueOf()
                );
              }}
              style={{ marginTop: '5px', width: '100%' }}
            />
          </Col>
          <Col span={4}>
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="End Date"
              value={(this.state.date && moment(this.state.date)) || null}
              onChange={(date) =>
                this.onChange({
                  target: {
                    name: 'date',
                    value: date && moment(date).format('YYYY-MM-DD'),
                  },
                })
              }
              disabledDate={(currentDate) => {
                if (!currentDate || !this.state.startDate) {
                  return false;
                }
                return (
                  currentDate.valueOf() < moment(this.state.startDate).valueOf()
                );
              }}
              style={{ marginTop: '5px', width: '100%' }}
            />
          </Col>
          <Col span={8}>
            <TSInput
              error=""
              value={head}
              onChange={(e) => this.setState({ head: e.target.value })}
              name="head"
              type="text"
              addonBefore="Search Expense Head"
              placeholder="Enter Expense"
            />
          </Col>
          <Col span={7}>
            <TSInput
              error=""
              value={branchName}
              name="locationName"
              type="text"
              addonBefore="Location Name"
            />
          </Col>
          {business?.type === 'company' && (
            <Col span={8}>
              <TSAutoComplete
                error={''}
                inputProps={{
                  name: 'branchId',
                  addonBefore: 'Change Location',
                }}
                dataSource={
                  business?.branches?.edges.filter(
                    (element) =>
                      element.node.category === BranchCategory.EMPORIUM,
                  ) || []
                }
                key="id"
                name="branchId"
                onValueSelect={(e) =>
                  this.setState({
                    branchId: e.target.value,
                    branchName: getValue(
                      business?.branches?.edges,
                      e.target.value,
                    ),
                  })
                }
                displayKey="name"
                textValue={getValue(business?.branches?.edges, branchId)}
              />
            </Col>
          )}
          {business?.type === 'company' && (
            <Col span={3}>
              <Button
                children="Clear Location"
                onClick={() =>
                  this.setState({ branchId: null, branchName: 'Head Office' })
                }
                style={{ marginTop: '5px', width: '100%' }}
              />
            </Col>
          )}
        </Row>
        <GraphqlQuery
          queryString={expenseEntryWithDateRangeQuery}
          variables={variables}
          render={(
            response: {
              allExpenseEntriesDateRange: ExpenseEntryNodeConnection;
            },
            error,
            loading,
          ) => {
            if (loading) {
              return <Skeleton />;
            }
            if (error) {
              return <h3>Something Went Wrong!!</h3>;
            }
            if (response && companyId) {
              return [
                <Table
                  key="table"
                  dataSource={response.allExpenseEntriesDateRange.edges}
                  columns={this.columns()}
                  rowKey={(obj) => obj.node?.id || ''}
                  pagination={false}
                  scroll={{ x: true }}
                />,
                <Pagination
                  key="pagination"
                  totalCount={
                    response.allExpenseEntriesDateRange.totalCount || 0
                  }
                  currentPage={currentPage}
                  batchSize={20}
                  cursorBasedPagination
                  onChange={(_p, _ps, next) =>
                    this.onPageChange(
                      next,
                      response.allExpenseEntriesDateRange.pageInfo.endCursor ||
                        '',
                      response.allExpenseEntriesDateRange.pageInfo.hasNextPage,
                    )
                  }
                  style={{ float: 'right' }}
                />,
                <Button
                  key="download"
                  style={{ float: 'right' }}
                  icon="download"
                  onClick={() => this.downloadCsv(variables)}
                  disabled={this.state.isLoading}
                />,
                <span style={{ float: 'right', margin: '7px' }}>
                  {this.state.message}
                </span>,
              ];
            }
            return <Spin />;
          }}
        />
      </>
    );
  }
}

interface State {
  startDate: string;
  date: string;
  currentPage: number;
  after: string;
  head: string;
  branchId?: string | null;
  isLoading: boolean;
  message: string;
  branchName: string | undefined;
}

interface Props {
  company: CompanyNodeEdge | null;
  companyId: string | null | undefined;
  branchId?: string | null | undefined;
  business: Bussiness | null;
}
